import { Typography, Button, Link, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { UploadMailings } from './components/UploadMailings';
import Estimations from './Estimations';
import ReportsTable from './components/reports-components/ReportsTable';
import useTable from '../../hooks/useTable';
import StyledTablePaper from './styled/StyledTablePaper';
import ListIcon from '@mui/icons-material/List';
import NoJobsSvg from '../../assets/no-jobs.svg';
import StyledRow from './styled/StyledRow';
import StyledColumn from './styled/StyledColumn';
import TrailingTwelveMonths from './components/TrailingTwelveMonths';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { useEffect } from 'react';
import { getDashboardMetrics } from 'src/features/user/utils';
import NoPaymentMethodAlert from './components/NoPaymentMethodAlert';
import { PaymentMethodsStatus } from 'src/utils/enums/payment-method-status.enum';

const DefaultMain = () => {
  const currentUser = useSelector((state: RootState) => state.user.currentUser);
  const { data, loading, error, updateData, page, rowsPerPage, setRowsPerPage, setPage, totalCount } = useTable({
    activityType: 'recent',
    role: currentUser.role,
  });
  const dashboardMetrics = useSelector((state: RootState) => state.user.dashboardMetrics);
  const dispatch = useDispatch<AppDispatch>();
  const paymentMethodsStatus = useSelector((state: RootState) => state.company.paymentMethodsStatus);

  useEffect(() => {
    dispatch(getDashboardMetrics());
  }, []);

  return (
    <StyledTablePaper length={data.length} elevation={0}>
      <StyledRow marginBottom="1.875rem">
        <Typography variant="h4" sx={{ fontSize: '3.25rem', fontFamily: 'ABC Arizona Mix', fontWeight: 300 }}>
          Welcome, {currentUser.firstName}!
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {paymentMethodsStatus === PaymentMethodsStatus.MISSING && (
            <NoPaymentMethodAlert isOrganizationAdmin={currentUser.role === 'admin'} />
          )}
          <UploadMailings sx={{ width: '10.625rem' }} />
        </Box>
      </StyledRow>
      <TrailingTwelveMonths />
      <Estimations metrics={dashboardMetrics} />
      <StyledRow marginBottom="0.9375rem">
        <Typography sx={{ fontSize: '1.875rem', fontFamily: 'Instrument Sans' }}>Recent Activity</Typography>
        <Link component={RouterLink} to="/history">
          <Button
            variant="contained"
            sx={{
              background: '#ffffff',
              fontFamily: 'Instrument Sans',
              textTransform: 'inherit',
              width: '10.625rem',
              maxHeight: '2.5rem',
              borderRadius: '0rem',
              color: '#000',
              border: '0.0625rem solid #d6d6d6',
              padding: '0.25rem 0.625rem',
            }}
            disableElevation
            startIcon={<ListIcon />}
          >
            Job History
          </Button>
        </Link>
      </StyledRow>
      {loading ? (
        <Typography
          sx={{
            textAlign: 'center',
            marginTop: '1rem',
            fontSize: 'large',
            fontWeight: 'bold',
          }}
        >
          Loading...
        </Typography>
      ) : error ? (
        <Typography
          sx={{
            textAlign: 'center',
            marginTop: '1rem',
            fontSize: 'large',
            fontWeight: 'bold',
          }}
        >
          Something Went Wrong
        </Typography>
      ) : data.length > 0 ? (
        <ReportsTable
          updateData={updateData}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          totalCount={totalCount}
          showUserColumn={currentUser.role === 'admin'}
          showPagination={true}
          data={data}
        />
      ) : (
        <StyledColumn>
          <img src={NoJobsSvg} alt="No jobs available." />
          <Typography
            sx={{
              textAlign: 'center',
              marginTop: '0.625rem',
              fontSize: 'large',
              fontWeight: 'bold',
              paddingLeft: '1.4rem',
            }}
          >
            No jobs submitted recently
          </Typography>
        </StyledColumn>
      )}
    </StyledTablePaper>
  );
};

export default DefaultMain;
